import { registerSW } from 'virtual:pwa-register';

export function initPWA() {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) {
    return;
  }

  registerSW({
    immediate: true,
    onRegistered(swRegistration) {
      if (swRegistration) {
        // src/sw.js handles both precaching and push events on this scope
        console.log('[LiveNow] Service worker registered', swRegistration.scope);
      }
    },
    onRegisterError(error) {
      console.error('[LiveNow] Service worker registration failed', error);
    }
  });

  // Listen for push notifications from service worker
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.addEventListener('message', (event) => {
      if (event.data && event.data.type === 'PUSH_NOTIFICATION') {
        handlePushNotification(event.data);
      }
    });
  }
}

function handlePushNotification(data) {
  // Handle push notification data on the client side
  // This can be used to update UI, show in-app notifications, etc.
  console.log('[LiveNow] Push notification received:', data);
  
  // Dispatch custom event for React components to listen to
  if (window.dispatchEvent) {
    window.dispatchEvent(new CustomEvent('pushNotification', { detail: data }));
  }
}
